import ErrorHandlingForm from "../../components/formValidation/ErrorHandlingForm";
import {useContext, useState} from "react";
import {validateOneOf, validateRequired} from "../../components/formValidation/validators";
import Typography from "@mui/material/Typography";
import {Stack} from "@mui/material";
import ConfigContext from "../../context/ConfigContext";
import CustomRadioGroup from "../../components/formValidation/CustomRadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const PaymentData = ({reference, data, setData}) => {
    const {config} = useContext(ConfigContext);
    const [errors, setErrors] = useState({
        payment: false,
    })
    const validators = {
        payment: [validateRequired, value => validateOneOf(value, ['card', 'simple'])]
    }
    return <ErrorHandlingForm
        reference={reference}
        data={data}
        setData={setData}
        errors={errors}
        setErrors={setErrors}
        validators={validators}
    >
        <Stack spacing={2}>
            <Typography id="payment-label" variant="caption" color='primary.main'>
                Fizetési mód*
            </Typography>
            <CustomRadioGroup
                data={data}
                setData={setData}
                errors={errors}
                setErrors={setErrors}
                validators={validators}
                name="payment"
                variant="standard"
                inputProps={{
                    "aria-labelledby": "payment-label",
                    "aria-required": "true",
                }}
            >
                {(config?.payment_authorized && config?.webshop_card_payment) &&
                    <FormControlLabel value="simple" control={<Radio/>} label="Online fizetés SimplePay rendszerrel"/>
                }
                {config?.webshop_cash_payment &&
                    <FormControlLabel value="card" control={<Radio/>} label="Fizetés a helyszínen"/>}

            </CustomRadioGroup>

        </Stack>
    </ErrorHandlingForm>
}

export default PaymentData;